import React from 'react';
import { Clock, TrendingDown, DollarSign, HelpCircle, AlertTriangle, UserX } from 'lucide-react';
import { painPoints } from '../data/content';

const iconMap = {
  Clock: Clock,
  TrendingDown: TrendingDown,
  DollarSign: DollarSign,
  HelpCircle: HelpCircle,
  AlertTriangle: AlertTriangle,
  UserX: UserX,
};

const PainPoints = () => {
  return (
    <section
      id="problemes"
      className="py-12 md:py-16"
      style={{ backgroundColor: '#E9DFCF' }}
      data-testid="pain-points-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {painPoints.map((pain, index) => {
            const IconComponent = iconMap[pain.icon];
            return (
              <div
                key={index}
                className="bg-white p-6 rounded-xl border border-gray-200 hover:border-red-200 transition-colors group"
                data-testid={`pain-point-card-${index}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-red-100 transition-colors">
                    {IconComponent && (
                      <IconComponent className="w-6 h-6 text-red-600" />
                    )}
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">
                      {pain.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {pain.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Bonne nouvelle : il existe une solution adaptée à votre situation.
          </p>
          <a
            href="#diagnostic"
            className="inline-flex items-center text-blue-700 font-semibold hover:text-blue-800 transition-colors"
            data-testid="pain-points-cta"
          >
            Évaluez votre potentiel IA
            <span className="ml-2">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PainPoints;
